/* eslint-disable jsdoc/require-jsdoc */
import React, { useState } from 'react';

function getOptionLabelFromId(optionId, options) {
  const option = options.find((opt) => opt.id === optionId);
  if (option) {
    return option.label;
  }

  return '';
}

function Select({
  label, value, onChange, options,
}) {
  const [isOpen, setIsOpen] = useState(false);

  function handleSelectionChange(option) {
    onChange(option.id);
  }

  return (
    <div className="filter__field">
      <label className="filter__field-label">{label}</label>
      <div
        className={`filter__field-input d-flex align-items-center hasDropdown ${isOpen && 'open'}`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="filter__field-input-caret" />
        <span className="m-l-5">{getOptionLabelFromId(value, options)}</span>
        <div className="filter__field-input-list">
          {options.map((d) => (
            <div
              key={d.id}
              className={`filter__field-input-list-item ${value === d.id && 'active'}`}
              onClick={handleSelectionChange.bind(null, d)}
            >
              {d.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Select;
